// extracted by mini-css-extract-plugin
module.exports = {"formCardTitle":"FormCardTitle_formCardTitle__2lr6-"};